import {
  Component,
  AfterViewInit,
  OnInit,
  ChangeDetectorRef,
} from "@angular/core";
import { MyserviceService } from "../../provider/myservice.service";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import { maps_vector_lang } from "../../language/maps_vector";
import * as L from "leaflet";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BsModalService } from "ngx-bootstrap/modal";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { defineLocale } from "ngx-bootstrap/chronos";
import { enGbLocale } from "ngx-bootstrap/locale";
import { thLocale } from "ngx-bootstrap/locale";
import { coordinate } from "openlayers";
import * as turf from "@turf/turf";
import { FeatureCollection, Geometry, GeometryCollection } from "geojson";
import { MultiPolygon } from "geojson";

defineLocale("engb", enGbLocale);
defineLocale("th", thLocale);
declare var url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class map_vector {
  place_id: string;
  place_address: string;
  place_type_description: string;
  fee_description: string;
  fee_count: number;
  fee_type_unit: string;
  fee_price: number;
  customer_name: string;
}

@Component({
  selector: "app-maps-vector",
  templateUrl: "./maps-vector.component.html",
  styleUrls: ["./maps-vector.component.scss"],
})
export class MapsVectorComponent implements AfterViewInit {
  token = "";
  database = "";
  dtOptions: DataTables.Settings = {};
  map_vectors: map_vector[];
  enable_google = false;
  map;
  lat = 19.14008388;
  lon = 99.91081981;
  marker = "";
  polygon;
  isLoading = true;
  showPage = false;
  lang = localStorage.getItem("lang") == "EN" ? "EN" : "TH";
  language: any;
  mapbox: any = null;

  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private localeService: BsLocaleService,
    private router: Router,
    private modalService: BsModalService
  ) {
    this.language = maps_vector_lang[this.lang];
  }

  ngOnInit() {
    if (sessionStorage.getItem("municipality") != undefined) {
      this.database =
        JSON.parse(sessionStorage.getItem("municipality")).municipality_id +
        "_fee";
    }

    if (sessionStorage.getItem("token") != undefined) {
      this.token = sessionStorage.getItem("token");
    }

    this.isLoading = false;
    this.showPage = true;
    const that = this;
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        console.log("customer-place/place-vectormap_to_datatable");
        that.http
          .post<DataTablesResponse>(
            url + "customer-place/place-vectormap_to_datatable",
            dataTablesParameters,
            {
              headers: new HttpHeaders({
                "Content-Type": "application/json; charset=utf-8",
                "x-access-token": this.token,
                database: this.database,
              }),
            }
          )
          .subscribe((resp) => {
            //debugger
            that.map_vectors = resp.data.map((item) => {
              return item;
            });
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: [],
            });
          });
      },
      columns: [
        { data: "cp.place_id" },
        { data: "cp.place_address" },
        { data: "ct.place_type_description" },
        // { data: '(fm.fee_price :: VARCHAR)' },
        { data: "customer_name" },
      ],
    };

    this.route.queryParams.subscribe((params) => {
      this.lang = params["lang"];
      if (this.lang != "EN" && this.lang != "TH") {
        this.lang = localStorage.getItem("lang") == "EN" ? "EN" : "TH";
        this.language = maps_vector_lang[this.lang];
      } else {
        this.language = maps_vector_lang[this.lang];
        localStorage.setItem("lang", this.lang);
      }
    });
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  private initMap(): void {
    var streets_satellite = L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution: "Mapbox",
        tileSize: 512,
        zoomOffset: -1,
        brightness: 1.2,
        maxZoom: 19,
        id: "mapbox/satellite-v9",
        accessToken:
          "pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw",
      }
    );

    var mapbox_streets = L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution: "Mapbox",
        tileSize: 512,
        zoomOffset: -1,
        maxZoom: 19,
        brightness: 1.2,
        id: "mapbox/streets-v11",
        accessToken:
          "pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw",
      }
    );

    var baseLayers = {
      Satellite_mapbox: streets_satellite,
      Streets_mapbox: mapbox_streets,
    };

    let layerControl = L.control.layers(baseLayers);

    // Initialize map and add base layers
    this.map = L.map("map", {
      center: [this.lat, this.lon],
      zoom: 13,
      layers: [streets_satellite],
    });

    // Add layer control to map
    layerControl.addTo(this.map);

    this.service.postData({}, "zone/get").then(async (e: any) => {
      const newdata = await e.data.map((feature: any) => {
        return {
          zone_id: feature.zone_id,
          id: feature.id,
          geometry: feature.coordinates,
          properties: feature.properties,
          type: feature.type,
          zone_name: feature.zone_name,
          block_coordinates: feature.block_coordinates,
        };
      });
      const newdata_ = await Promise.all(newdata);
      this.mapbox = newdata_;
      const bule = newdata_.filter((feature: any) => feature.zone_idd == null);

      var css =
        ".text-label { background-color: transparent; color: white; font-size: 13px; border: none; }";
      var style = document.createElement("style");
      style.type = "text/css";
      style.appendChild(document.createTextNode(css));
      document.head.appendChild(style);

      const zone = L.geoJSON(bule, {
        style: { color: "blue", fillOpacity: 0.4 },
        onEachFeature: (feature: any, layer: any) => {
          layer
            .bindTooltip(feature.zone_id, {
              permanent: true,
              direction: "center",
              className: "text-label",
              // opacity: 0.9
            })
            .openTooltip();
          layer.bindPopup( `<p style="font-size: 12px;">
          โซน: ${feature.zone_name}<br>
          </p>`
            );
          layer.on('mouseover', function() {
            this.openPopup();
          });
          layer.on('mouseout', function() {
            this.closePopup();
          });
        },
      });
      zone.addTo(this.map);
      
      

      const newGeoJsonLayer = L.geoJSON(bule, {
        style: { color: "blue", fillOpacity: 0.4 },
        onEachFeature: (feature: any, layer: any) => {
          layer
            .bindTooltip(feature.zone_name, {
              permanent: true,
              direction: "center",
              className: "text-label",
              // opacity: 0.9
            })
            .openTooltip();
        },
      });
      zone.addTo(this.map);

      this.map.on("zoomend", () => {
        if (this.map.getZoom() >= 15) {
          newGeoJsonLayer.addTo(this.map);
          layerControl.addOverlay(newGeoJsonLayer, "New GeoJSON");
          this.map.removeLayer(zone);
        } else {
          this.map.removeLayer(newGeoJsonLayer);
          layerControl.removeLayer(newGeoJsonLayer);
          zone.addTo(this.map);
        }
      });
    });
  }

  onClickRow(item) {
    console.log(item);
    var customIcon = L.icon({
      iconUrl: "../../../assets/img/marker-icon-2x.png",
      iconSize: [30, 45],
      iconAnchor: [23, 35],
      popupAnchor: [-2, -38],
    });

    if (this.marker) {
      this.map.removeLayer(this.marker);
    }
    if (this.polygon) {
      this.map.removeLayer(this.polygon);
    }

    if (item.coordinates) {
      // Check if item.coordinates is defined
      this.lat = item.lat;
      this.lon = item.lon;
      this.map.panTo([this.lat, this.lon]);

      let data_geojson: FeatureCollection<MultiPolygon, any> = {
        type: "FeatureCollection",
        features: [
          {
            type: "Feature",
            properties: {},
            geometry: {
              type: "MultiPolygon",
              coordinates: JSON.parse(item.coordinates),
            },
          },
        ],
      };

      console.log(data_geojson);
      this.polygon = L.geoJSON(data_geojson, {
        pointToLayer: function (feature, latlng) {
          var marker = L.marker(latlng);
          marker.bindPopup(
            `<p>Feature properties: ${JSON.stringify(feature.properties)}</p>`
          );
          return marker;
        },
      }).addTo(this.map);

      // calculate the center of the geojson
      let center = turf.center(data_geojson);
      let marker = L.marker(
        [center.geometry.coordinates[1], center.geometry.coordinates[0]],
        { icon: customIcon }
      );
      marker.bindPopup(
        `<p style="font-size: 12px;">
          ชื่อ-นามสกุล: ${item.customer_name}<br>
          ที่อยู่: ${item.place_address}<br>
          ประเภทที่อยู่: ${item.place_type_description}<br>
          ${
            item.zone_name
              ? `โซนที่อยู่: ${item.zone_name}<br>`
              : "โซนที่อยู่: ไม่มีข้อมูลโซน<br>"
          }
        </p>`
      );
      marker.addTo(this.map);
      marker.openPopup();
      this.marker = marker;
      this.map.setView(
        [center.geometry.coordinates[1], center.geometry.coordinates[0]],
        100
      );
    } else {
      let marker = L.marker([item.lat, item.lon], { icon: customIcon });
      marker.bindPopup(
          `<p style="font-size: 12px;">
              ชื่อ-นามสกุล: ${item.customer_name}<br>
              ที่อยู่: ${item.place_address}<br>
              ${
                  item.place_type_description
                      ? "ประเภทที่อยู่: " + item.place_type_description + "<br>"
                      : ""
              }
              ${
                  item.zone_name !== null
                      ? "โซนที่อยู่: " + (item.zone_name || "") + "<br>"
                      : "ไม่มีข้อมูลโซน<br>"
              }
          </p>`
      );
      

      marker.addTo(this.map);
      marker.openPopup();
      this.marker = marker;
      this.map.setView([item.lat, item.lon], 100);
    }
  }
}
